import Swiper, { Scrollbar, FreeMode } from "swiper";

// import Swiper and modules styles
import "swiper/css";
import "swiper/css/scrollbar";
import "swiper/css/free-mode";

// configure Swiper to use modules
Swiper.use([Scrollbar, FreeMode]);

export default class TableOfContent {
	constructor(config) {
		this.el = config.el;
		this.swiper = this.el.querySelector(".table-of-content-swiper");
		this.init();
	}

	init() {
		this.setSwiper();
	}

	setSwiper() {
		new Swiper(this.swiper, {
			slidesPerView: "auto",
			spaceBetween: 0,
			freeMode: true,
			scrollbar: {
				el: ".table-of-content__swiper-scrollbar",
				draggable: true,
				hide: false,
				snapOnRelease: false,
			},
		});
	}
}
